module.exports = __webpack_public_path__ + "static/media/ic-date.cb5fea18.svg";